import type { FC } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Bucket, InputDatepicker, InputNumber } from '@eneco/sparky';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from './types';
import type { CorrectionInvoiceFormContent } from '../correction-invoice-form-content.types';

type Props = {
  content: CorrectionInvoiceFormContent;
};

/** Mirrors the legacy `components/InvoiceDetails.tsx`. */
export const InvoiceDetails: FC<Props> = ({ content }) => {
  const { formFieldsInvoice_title, invoiceDateFormField, invoiceNumberFormField } = content;
  const { date } = useFormatter();

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <Bucket title={formFieldsInvoice_title ?? ''}>
      <Bucket.Content>
        <InputNumber
          {...register('invoiceId')}
          label={invoiceNumberFormField?.label ?? ''}
          error={errors.invoiceId?.message}
          formatOptions={{ useGrouping: false }}
        />
        <Controller
          control={control}
          name="invoiceDate"
          render={({ field: { onChange, value, name } }) => (
            <InputDatepicker
              name={name}
              isReadOnly
              label={invoiceDateFormField?.label ?? ''}
              value={value}
              onDaySelect={d => onChange(d && date.short(d as Date))}
              fromYear={2000}
              toYear={new Date().getFullYear()}
              error={errors.invoiceDate?.message}
            />
          )}
        />
      </Bucket.Content>
    </Bucket>
  );
};
